document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.custom-tabs').forEach(tabContainer => {

    const buttons = tabContainer.querySelectorAll('.decktok-tab-btn');
    const panels  = tabContainer.querySelectorAll('.decktok-tab-panel');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {

        buttons.forEach(b => b.classList.remove('dkactive'));
        btn.classList.add('dkactive');

        const target = btn.dataset.tab;
        panels.forEach(panel => {
          panel.classList.toggle(
            'dkhidden',
            panel.dataset.panel !== target
          );
        });
      });
    });

    const defaultBtn = tabContainer.querySelector('.decktok-tab-btn.dkactive') || buttons[0];
    defaultBtn && defaultBtn.click();

  });
});

document.addEventListener('DOMContentLoaded', () => {
  const pairs = ['1', '2', '3' ,'4','5']; // ← 以后加 4、5 只需在这里加 '4', '5' 等

  let activeTimer;

  function hideAll() {
    pairs.forEach(num => {
      const megaLink = document.querySelector(`.megameau${num} a`);
      const guider = document.querySelector(`.guider${num}`);
      if (megaLink) megaLink.classList.remove('hovered-by-panel');
      if (guider) guider.classList.remove('show');
    });
  }

  // 显示指定编号的 guider
  function showGuider(num) {
    clearTimeout(activeTimer);
    hideAll();
    const megaLink = document.querySelector(`.megameau${num} a`);
    const guider = document.querySelector(`.guider${num}`);
    if (megaLink) megaLink.classList.add('hovered-by-panel');
    if (guider) guider.classList.add('show');
  }

  // 延迟隐藏
  function delayedHide() {
    activeTimer = setTimeout(hideAll, 150);
  }

  // 为每个 pair 绑定事件
  pairs.forEach(num => {
    const mega = document.querySelector(`.megameau${num}`);
    const guider = document.querySelector(`.guider${num}`);

    if (!mega || !guider) return; // 防止元素不存在报错

    const show = () => showGuider(num);

    // mega hover
    mega.addEventListener('mouseenter', show);
    mega.addEventListener('mouseleave', delayedHide);

    // guider hover
    guider.addEventListener('mouseenter', show);
    guider.addEventListener('mouseleave', delayedHide);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.querySelector('.hamburger-checkbox');
  const menu = document.querySelector('.mobilemeau');
  const body = document.body;

  const resetEverything = () => {
    if (checkbox) checkbox.checked = false; 
    menu?.classList.remove('navshow');
    body?.classList.remove('no-scroll');
  };

  checkbox?.addEventListener('change', () => {
    const isChecked = checkbox.checked;
    menu?.classList.toggle('navshow', isChecked);
    body?.classList.toggle('no-scroll', isChecked);
  });

  // 2. 核心修复：监听浏览器显示事件
  window.addEventListener('pageshow', (event) => {
    resetEverything();
  });
});